import type { ApiErrorPayload } from "../shared/types";

export class ClientApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string,
  ) {
    super(message);
    this.name = "ClientApiError";
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...init,
    headers: {
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  if (!response.ok) {
    let payload: ApiErrorPayload = { error: `요청에 실패했습니다. (${response.status})` };
    try {
      payload = await response.json<ApiErrorPayload>();
    } catch {
      // Keep the status fallback for non-JSON proxy errors.
    }
    throw new ClientApiError(payload.error, response.status, payload.code);
  }
  return response.json<T>();
}
